const pccvRealms = ['Motorcade', 'Acorn'];

const isPCCV = () => {
	const realm = import.meta.env.VITE_AUTH_REALM;
	return pccvRealms.includes(realm);
};

export default isPCCV;
